import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import { useCallback, useState } from 'react'
import FilterListIcon from '@mui/icons-material/FilterList'

import { SideDrawer } from '@sales-center/components'

import Button from '@mui/material/Button'
import { Formik, FormikErrors, FormikHelpers } from 'formik'
import { Filters } from '@user/components/Filters/Filters'
import { IFilterSet, IOrderBy } from '@user/components/Filters'

export interface GridFilterProps<T> {
  applyCallback: (model: T) => void
  initialValues: T
  defaultValues: T
  clearedValues: T
  filterComponent: React.ComponentType
  orderOptions: IOrderBy[]
  validate?: (model: T) => FormikErrors<T>
  hideOrderBy?: boolean
  disabled?: boolean
  disableInteraction?: boolean
  hideCreatedBy?: boolean
  appliedCount?: number
}

export const GridFilter = <U, T extends IFilterSet<U>>(
  props: GridFilterProps<T>,
) => {
  const { applyCallback, disableInteraction, appliedCount } = props
  const [reset, setReset] = useState(false)
  const [open, setOpen] = useState(false)
  const onOpen = useCallback(() => setOpen(true), [])
  const onClose = useCallback(() => setOpen(false), [])
  const theme = useTheme()

  const onReset = useCallback(
    (v: boolean) => {
      setReset(v)
    },
    [setReset],
  )

  const onSubmit = useCallback(
    (model: T, { setSubmitting }: FormikHelpers<T>) => {
      applyCallback(model)
      setSubmitting(false)
      onClose()
    },
    [applyCallback, onClose],
  )

  return (
    <>
      <Button color="primary" onClick={onOpen} disabled={disableInteraction}>
        <FilterListIcon
          fontSize="small"
          style={{ marginRight: theme.spacing(0.5) }}
        />
        {`Filters ${appliedCount ? ` (${appliedCount})` : ''}`}
      </Button>
      <SideDrawer title="Filters" open={open} onClose={onClose} width={420}>
        <Formik {...props} onSubmit={onSubmit} onReset={() => onReset(true)}>
          <Filters<U, T>
            {...props}
            onClose={onClose}
            reset={reset}
            onFocus={() => onReset(false)}
          />
        </Formik>
      </SideDrawer>
    </>
  )
}
